import {i18n, Icon} from 'mc/lib';
import * as TypSubjektu from 'mc/lib/api/gen/proxioapi/TypSubjektu';
import {ModalActions} from 'mc/lib/modal';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown} from 'reactstrap';
import './Subjekt.scss';
import SubjektFormFo from './SubjektFormFo';
import SubjektFormFop from './SubjektFormFop';
import SubjektFormPo from './SubjektFormPo';
import {formatSubjekt, getTypSubjektu} from './utils';

const subjektForms = {
    [TypSubjektu.FO]: SubjektFormFo,
    [TypSubjektu.FOP]: SubjektFormFop,
    [TypSubjektu.PO]: SubjektFormPo,
};

export default class Subjekt extends PureComponent {

    static propTypes = {
        subjekt: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
    };

    handleEditFo = () => {
        this.showModal(TypSubjektu.FO);
    };

    handleEditFop = () => {
        this.showModal(TypSubjektu.FOP);
    };

    handleEditPo = () => {
        this.showModal(TypSubjektu.PO);
    };

    handleEdit = () => {
        this.showModal(getTypSubjektu(this.props.subjekt));
    };

    showModal(typSubjektu) {
        const form = subjektForms[typSubjektu];
        if (form) {
            const {dispatch, subjekt, onChange} = this.props;
            const formProps = {
                onSubmit: newSubjekt => {
                    return Promise.resolve(onChange(newSubjekt, subjekt)).then(() => {
                        dispatch(ModalActions.hide());
                    });
                },
                initialValues: subjekt,
            };
            dispatch(ModalActions.show(form, formProps, i18n('modal.userSubjekt')));
        }
    }

    render() {
        const {subjekt, onDelete} = this.props;

        if (subjekt) {
            return (
                <div className="subjekt">
                    <Button color="link" onClick={this.handleEdit}>{formatSubjekt(subjekt)}</Button>
                    <Button className="subjekt-tool" size="xs" color="link" onClick={this.handleEdit}>
                        <Icon icon="pencil"/>
                    </Button>
                    <Button className="subjekt-tool" size="xs" color="link" onClick={onDelete}>
                        <Icon icon="trash"/>
                    </Button>
                </div>
            )
        }

        return (
            <div className="subjekt">
                <UncontrolledButtonDropdown>
                    <DropdownToggle caret color="link">Zadat subjekt</DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={this.handleEditFo}>{i18n("subjekt.typSubjekt.FO")}</DropdownItem>
                        <DropdownItem onClick={this.handleEditFop}>{i18n("subjekt.typSubjekt.FOP")}</DropdownItem>
                        <DropdownItem onClick={this.handleEditPo}>{i18n("subjekt.typSubjekt.PO")}</DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            </div>
        )
    }

}
